/* ==========================================================================
   Theme JS
   ========================================================================== */

document.addEventListener("DOMContentLoaded", () => {

});